import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'language-settings.sidebar-translations.title',
		defaultMessage: '{language} translations',
		description:
			'Title for the translations sidebar nav with a placeholder for the selected language',
	},
	changeIndicatorLabel: {
		id: 'language-settings.sidebar-translations.change-indicator-label',
		defaultMessage: 'Translations missing',
		description:
			'A11y label for the ChangeIndicator icon. Icon is shown when there are texts that need to be translated.',
	},
});
